import React, { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { buildAppPath } from '@/utils/tenant';
import Loader from 'wrapper/loader';

// Lead gen sees only Loan Information (plus the loan workspace they open
// into). Every other B2B page, Dashboard and Pipeline included, is left out on
// purpose so it can't be reached by URL either; the many links to /dashboard
// land on Loan Information instead.
const Login = lazy(() => import('@/pages/shared/auth/login/Login'));
const LoanInformation = lazy(() => import('@/pages/b2b/loan-management/loan-information'));
const NotFound = lazy(() => import('components/404'));
const BorrowerProfile = lazy(() => import('@/pages/b2b/loan-management/borrower-profile'));
const HelpSupport = lazy(() => import('@/pages/shared/help-support'));
const CompanyOnboarding = lazy(() => import('@/pages/b2b/onboarding/CompanyOnboarding'));

const suspenseFallback = <Loader />;

const withSuspense = (element) => <Suspense fallback={suspenseFallback}>{element}</Suspense>;

// Resolved when it renders, so the tenant path prefix is current.
const ToLoanInformation = () => <Navigate to={buildAppPath('/loanInformation')} replace />;

const leadGenRoutes = [
  {
    path: '/',
    element: withSuspense(<Login />),
    children: [
      { path: 'onboard', element: withSuspense(<CompanyOnboarding />) },
      { path: 'dashboard', element: <ToLoanInformation /> },
      { path: 'loanInformation', element: withSuspense(<LoanInformation />) },
      { path: ':param/lead', element: withSuspense(<BorrowerProfile />) },
      { path: 'help-support', element: withSuspense(<HelpSupport />) },
      { path: '*', element: withSuspense(<NotFound />) },
    ],
  },
];

export default leadGenRoutes;
